import Icon from '../components/Icon.vue'

Icon.register({"get-pocket":{"width":1720,"height":1792,"paths":[{"d":"M1565 128q65 0 110 45.5t45 110.5v519q0 176-68 336t-182.5 275-274 182.5-334.5 67.5q-176 0-335.5-67.5t-274.5-182.5-183-275-68-336v-519q0-64 46-110t110-46h1409zM861 1192q47 0 82-33l404-388q37-35 37-85 0-49-34.5-83.5t-83.5-34.5q-47 0-82 33l-323 310-323-310q-35-33-81-33-49 0-83.5 34.5t-34.5 83.5q0 51 36 85l405 388q33 33 81 33z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/get-pocket.js
// module id = 1427
// module chunks = 0